module.exports = __webpack_public_path__ + "static/media/geo_minimal.3af3f5e2.png";